import { createReducer } from '@reduxjs/toolkit'
import { SET_NOTIFICATIONS } from './actions'
import { SUCCESS, REQUEST, FAILURE } from '../../constants/statuses'

const initialState = {
  notifications: [],
  pagination: {
    page: 1,
    perPage: 10,
    amount: 2
  },
  isLoading: false,
  isError: false
}

export const notificationsReducer = createReducer(initialState, {
  [SET_NOTIFICATIONS[SUCCESS]]: (state, action) => {
    state.notifications = action.payload.data.messages
    state.pagination.amount = action.payload.data.amount
    state.pagination.page = action.payload.paging.page
    if (action.payload.paging.count !== 9999) {
      state.pagination.perPage = action.payload.paging.count
    }
    state.isLoading = false
  },

  [SET_NOTIFICATIONS[REQUEST]]: (state, action) => {
    state.isError = false
    state.isLoading = true
  },

  [SET_NOTIFICATIONS[FAILURE]]: (state, action) => {
    state.isLoading = false
    state.isError = true
  }
})
